import { render, staticRenderFns } from "./MyWalletAddressCard.vue?vue&type=template&id=0d49f312&scoped=true"
import script from "./MyWalletAddressCard.vue?vue&type=script&lang=ts"
export * from "./MyWalletAddressCard.vue?vue&type=script&lang=ts"
import style0 from "./MyWalletAddressCard.vue?vue&type=style&index=0&id=0d49f312&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d49f312",
  null
  
)

export default component.exports